import { ChevronLeft, ChevronRight } from 'lucide-react';

const SwiperNavButton = ({ direction = 'next', onClick, className = '', disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`absolute top-1/2 -translate-y-1/2 z-10 
        ${direction === 'next' ? '-right-6' : '-left-6'}
        hidden md:flex items-center justify-center
        w-12 h-12 rounded-full
        bg-white/90 backdrop-blur-sm
        border border-gray-200
        shadow-lg hover:shadow-xl
        transition-all duration-200
        group
        disabled:opacity-0 disabled:pointer-events-none
        ${className}`}
      aria-label={direction === 'next' ? 'Next' : 'Previous'}
    >
      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#24ccf2]/0 via-[#2476f2]/0 to-purple-500/0 opacity-0 group-hover:opacity-100 group-hover:from-[#24ccf2]/10 group-hover:via-[#2476f2]/10 group-hover:to-purple-500/10 transition-opacity duration-200" />
      {direction === 'next' ? (
        <ChevronRight className="w-6 h-6 text-gray-700 relative" />
      ) : (
        <ChevronLeft className="w-6 h-6 text-gray-700 relative" />
      )}
    </button>
  );
};

export default SwiperNavButton;